(() => {
  const KEY = 'hartfield-public-favourites-v1';
  const handleOK = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,199}$/.test(value);
  const safeImage = value => { try { const u = new URL(value, 'https://www.hartfield.co.nz'); return u.protocol === 'https:' && !u.username && !u.password && ['cdn.shopify.com','www.hartfield.co.nz'].includes(u.hostname) ? u.href : null; } catch { return null; } };
  const read = () => {
    try { const raw = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(raw) ? raw.filter(p => handleOK(p?.handle) && typeof p.name === 'string' && p.name.length <= 500).slice(0,30) : []; } catch { return []; }
  };
  for (const root of document.querySelectorAll('[data-hartfield-favourites]')) {
    if (root.dataset.favouritesReady) continue;
    root.dataset.favouritesReady = 'true';
    const dialog = root.querySelector('dialog'), status = root.querySelector('[data-favourites-status]');
    const text = name => root.querySelector('[data-favourites-' + name + ']').textContent;
    const write = pieces => { try { localStorage.setItem(KEY, JSON.stringify(pieces)); return true; } catch { status.textContent = text('storage'); return false; } };
    const showList = () => {
      root.querySelector('[data-favourites-choices]').hidden = true;
      root.querySelector('[data-favourites-list-view]').hidden = false;
      root.querySelector('[data-favourites-email] input').disabled = false;
      const list = root.querySelector('[data-favourites-list]'), pieces = read();
      list.replaceChildren();
      if (!pieces.length) list.textContent = text('empty');
      root.querySelector('[data-favourites-email] button').disabled = !pieces.length;
      for (const piece of pieces) {
        const row = document.createElement('div'); row.className = 'hartfield-favourite-row';
        const image = document.createElement('img'); image.alt = ''; image.width = 64; image.height = 64;
        const src = safeImage(piece.image); if (src) image.src = src;
        const link = document.createElement('a'); link.href = '/products/' + piece.handle; link.textContent = piece.name;
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = text('remove'); remove.setAttribute('aria-label', text('remove') + ' ' + piece.name);
        remove.addEventListener('click', () => { if (write(read().filter(p => p.handle !== piece.handle))) showList(); });
        row.append(image,link,remove); list.append(row);
      }
    };
    root.querySelector('.hartfield-save-trigger').addEventListener('click', () => {
      status.textContent = ''; root.querySelector('[data-favourites-choices]').hidden = false;
      root.querySelector('[data-favourites-list-view]').hidden = true; dialog.showModal();
    });
    for (const button of root.querySelectorAll('[data-favourites-close]')) button.addEventListener('click', () => dialog.close());
    root.querySelector('[data-favourites-view]').addEventListener('click', showList);
    root.querySelector('[data-favourites-add]').addEventListener('click', () => {
      const piece = {handle:root.dataset.pieceHandle,name:root.dataset.pieceName.slice(0,500),image:safeImage(root.dataset.pieceImage)};
      if (!handleOK(piece.handle)) return;
      const existing = read();
      if (existing.length >= 30 && !existing.some(p => p.handle === piece.handle)) { status.textContent = text('limit'); return; }
      if (write([piece,...existing.filter(p => p.handle !== piece.handle)])) { status.textContent = ''; showList(); }
    });
    const emailBox = root.querySelector('[data-favourites-email]');
    dialog.addEventListener('close', () => { emailBox.querySelector('input').disabled = true; });
    const emailList = event => {
      event.preventDefault(); const email = emailBox.querySelector('input');
      if (!email.reportValidity()) return;
      const pieces = read(); if (!pieces.length) return;
      const body = 'My Hartfield favourites\n\n' + pieces.map(p => p.name + '\nhttps://www.hartfield.co.nz/products/' + p.handle).join('\n\n') + '\n\nFor availability or a private viewing, visit https://www.hartfield.co.nz/pages/by-appointment';
      window.location.href = 'mailto:' + encodeURIComponent(email.value.trim()) + '?subject=' + encodeURIComponent('My Hartfield favourites') + '&body=' + encodeURIComponent(body);
    };
    emailBox.querySelector('button').addEventListener('click', emailList);
    emailBox.querySelector('input').addEventListener('keydown', event => { if (event.key === 'Enter') emailList(event); });
  }
})();
